import { render, staticRenderFns } from "./App.vue?vue&type=template&id=768f2ef3&lang=pug"
import script from "./App.vue?vue&type=script&lang=coffee"
export * from "./App.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports